
import Vue from 'vue';
import gsap from 'gsap';
import { CustomEase } from 'gsap/dist/CustomEase';
import { transformLink } from '~/transforms/transformComponents';

gsap.registerPlugin(CustomEase);
CustomEase.create('curveAppear', '.03,0,.2,1');
CustomEase.create('curveTech', '.2,0,.8,1');

export default Vue.extend({
  props: {
    showAlways: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'green',
    },
    items: {
      type: Array as () => Array<{
        id: string;
        isPermanent: boolean;
        isWarning: boolean;
        isShown: boolean;
        headline: string;
        copy: string;
        pageSlugs: string[];
        link: {
          url: string;
          label: string;
        };
      }>,
      default: () => [],
    },
  },
  data() {
    return {
      isVisible: false,
      visibleItems: this.items,
      flickityOptions: {
        wrapAround: true,
        prevNextButtons: false,
        pageDots: true,
        adaptiveHeight: false,
      },
    };
  },
  methods: {
    checkVisibility() {
      if (!this.items.length) {
        this.isVisible = false;
        return;
      }
      const alertsStorage = sessionStorage.getItem('alertsClosed');

      let alertsClosed: any[] = [];
      alertsClosed = (alertsStorage && JSON.parse(alertsStorage)) || [];

      if (this.showAlways) {
        this.visibleItems = this.items.filter(
          item =>
            alertsClosed.some(closed => {
              if (item.isPermanent && closed.id === item.id) {
                closed.isShown = true;
                return true;
              }
              return false;
            }) ||
            (item.isPermanent && item.pageSlugs.length === 0)
        );

        if (!this.visibleItems.length) {
          this.isVisible = false;
          return;
        }
        this.isVisible = true;
        sessionStorage.setItem('alertsClosed', JSON.stringify(alertsClosed));

        return;
      }
      this.visibleItems = this.items.filter(item => {
        return (
          (item.pageSlugs.some(page => page === this.$route.path.replace(/\/$/, '')) || item.pageSlugs.length === 0) &&
          !alertsClosed.some(closed => closed.id === item.id)
        );
      });

      if (this.visibleItems.length === 0) {
        this.isVisible = false;
        return;
      }

      this.isVisible = true;
    },

    closeAlert() {
      const alertsStorage = sessionStorage.getItem('alertsClosed');

      let alertsClosed = (alertsStorage && JSON.parse(alertsStorage)) || [];

      this.visibleItems.forEach(item => {
        if (item.isPermanent) this.$root.$emit('setIndicator');
        alertsClosed.push(item);
      });

      sessionStorage.setItem('alertsClosed', JSON.stringify(alertsClosed));

      this.isVisible = false;
      this.visibleItems = [];
    },

    transformLink(link: { url: string; label: string }) {
      return transformLink(link, link?.label);
    },

    initAnimation() {
      if (!process.client) return;

      gsap.config({ nullTargetWarn: false });

      // ---> set module visible

      const module = this.$el as HTMLElement;
      gsap.to(module, { opacity: 1, duration: 0.1, ease: 'curveAppear' });

      // ---> clipPath

      const clipPathList = this.$el.querySelectorAll('#bm-alert__bg-shape-clipPath path') as NodeList;

      // gsap.set(clipPathList[0], { rotation: 180 })
      // gsap.set(clipPathList[1], { rotation: -180 })
      const alertContent = this.$el.querySelector('.bm-alert__content') as HTMLElement;
      const alertClose = this.$el.querySelector('.bm-alert__close') as HTMLElement;
      gsap.set(alertContent, { opacity: 0 });
      gsap.set(alertClose, { opacity: 0 });

      // gsap.set(clipPathList[0], { rotation: 180 })
      // gsap.set(clipPathList[1], { rotation: -180 })
      gsap.set(clipPathList, { rotation: -180 });

      gsap.to(alertContent, { opacity: 1, duration: 0.6, delay: 0.8 });
      gsap.to(alertClose, { opacity: 1, delay: 0.8, duration: 0.2 });

      gsap.set(clipPathList, { rotation: -180 });
      gsap.set(clipPathList[1], { autoAlpha: 0 });
      gsap.set(clipPathList[1], { autoAlpha: 1, delay: 0.6 });

      gsap.to(clipPathList[0], { rotation: 0, duration: 0.6, ease: 'curveTech', force3D: true });
      gsap.to(clipPathList[1], { rotation: 0, duration: 0.6, ease: 'curveTech', force3D: true, delay: 0.2 });
    },
  },
  mounted() {
    if (this.showAlways) {
      this.checkVisibility();
    } else {
      setTimeout(() => {
        this.checkVisibility();
      }, 1200);
    }
  },
  updated() {
    if (this.$refs.flickity) {
      this.initAnimation();
      (this.$refs.flickity as any).resize();
    }
  },
});
